import { useEffect } from "react";
import { LngLatBounds, LngLatBoundsLike, MapEvent, useMap } from "react-map-gl/maplibre";
import { maybe } from "shared/utils/maybe";

export const MapControlledBoundsOverlay = (props: { bounds?: LngLatBoundsLike; onBoundsChange?: (bounds: LngLatBounds) => void }) => {
    const map = useMap();

    useEffect(() => {
        if (!map.current || !props.bounds || map.current.getBounds().toArray().toString() == props.bounds.toString()) {
            return;
        }

        map.current.fitBounds(props.bounds, {
            animate: false,
        });
    }, [props.bounds, map]);

    useEffect(() => {
        if (!map.current) {
            return;
        }

        function moveend(e: MapEvent) {
            maybe(e.target.getBounds())?.take((it) => props.onBoundsChange?.(it));
        }

        map.current.on("moveend", moveend);

        return () => {
            map.current?.off("moveend", moveend);
        };
    }, [map, props.onBoundsChange]);

    return null;
};
